export const CHANGE = { INCREASE: 0, DECREASE: 0 };
export const CURRENCY = { WFIRO: 0, BNB: 1 };
